import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useAuthStore from "store/authStore";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useBooksInSubscriptionCollection = (queryParams) => {
	const { accessToken } = useTokenStore();
	const loggedIn = useAuthStore((state) => state.loggedIn);
	const fetch = async () => {
		if (!loggedIn) {
			return null;
		}
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const response = await instance.get("books/subscribed", {
			params: { ...params },
		});
		return response.data;
	};
	return useQuery(["picks", queryParams], () => fetch(), {
		...fetchConfig,
	});
};

export default useBooksInSubscriptionCollection;
